import { DiscountCodeData } from '@app/domain/model/eshop/transport/DiscountCodeData';
import { InsuredTraveler } from '@app/domain/model/eshop/travel/InsuredTraveler';
import { TravelPremiumRisk } from '@app/domain/model/eshop/travel/TravelPremiumRisk';
import { FormState } from '@app/lib/form/contracts/FormState';
import {
    purchaseTravelInsurance,
    PurchaseTravelInsuranceResult,
} from '@app/service/eshop/travel/actions/purchaseTravelInsurance';
import { TravelInsuranceRequestResult } from '@app/service/eshop/travel/actions/requestTravelInsurance';

export function createEnhancedFormAction(
    discountCodeData: DiscountCodeData,
    insuredPersons: InsuredTraveler[],
    requestResult: TravelInsuranceRequestResult,
    selectedRisks: TravelPremiumRisk[],
    isReinitializedSession?: boolean,
) {
    return async (prevState: FormState<PurchaseTravelInsuranceResult>, formData: FormData) => {
        if (discountCodeData.validTravelCode) {
            formData.append('discountCode', discountCodeData.validTravelCode);
        }

        if (selectedRisks.length > 0) {
            formData.append('selectedRisks', JSON.stringify(selectedRisks));
        }

        formData.append('insuredPersons', JSON.stringify(insuredPersons));

        return purchaseTravelInsurance(prevState, formData, requestResult, isReinitializedSession);
    };
}
